import enTeam from './en';
import ruTeam from './ru';

export default {
  en: {
    ...enTeam,
  },
  ru: {
    ...ruTeam,
  },
};
